import { defaultPagination } from 'helpers';
import { DataWithPagination } from 'services/api';

export const initialTagsDataWithPagination: DataWithPagination = {
  data: [],
  pagination: { ...defaultPagination, pageSize: 50 },
};
